import { httpInterceptor } from '../http-interceptor';

export class InventoryService {
                static ENDPOINTS = {
                GET_ALL: 'inventory/getinventorylist',
                QUARANTINE: 'inventory/quarantine',
                RELEASE: 'inventory/release',
                DELETE: 'shipment/delete',
                GET_BY_ID: 'inventory/getinventorydetails',
                GET_INVENTORY_DETAILS: 'inventory/getinventorydetails',
                GET_RECEIVING_INVENTORY_DETAILS: 'inventory/getreceivinginventorydetails',
                IMPORT_SHIPMENT: 'shipment/uploadshipment',
                PRINT_RECEIVING_LABEL: 'inventory/printreceivinglabel',

            };

  static async getAllInventory(data) {
    return httpInterceptor.post(this.ENDPOINTS.GET_ALL, data);
  }

                static async getInventoryById(id) {
                return httpInterceptor.get(`${this.ENDPOINTS.GET_BY_ID}/${id}`);
              }

              static async getInventoryDetails(partId, pageNumber = 1, pageSize = 10, highlightSerialNumber = '') {
                // Controller route expects highlightSerialNumber as path segment.
                // If empty, send a harmless placeholder so route still matches.
                const highlight = highlightSerialNumber ? encodeURIComponent(highlightSerialNumber) : '0';
                return httpInterceptor.get(
                  `${this.ENDPOINTS.GET_INVENTORY_DETAILS}/${partId}/${pageNumber}/${pageSize}/${highlight}`,
                );
              }

              static async getReceivingInventoryDetails(partId) {
                return httpInterceptor.get(`${this.ENDPOINTS.GET_RECEIVING_INVENTORY_DETAILS}/${partId}`);
              }

  static async createShipment(data) {
    return httpInterceptor.post(this.ENDPOINTS.CREATE, data);
  }
  static async Quarantine(data) {
    return httpInterceptor.post(this.ENDPOINTS.QUARANTINE, data);
  }
  static async Release(data) {
    return httpInterceptor.post(this.ENDPOINTS.RELEASE, data);
  }
  static async importShipment(data) {
    return httpInterceptor.postfile(this.ENDPOINTS.IMPORT_SHIPMENT, data);
  }
  static async updateShipment(id, data) {
    return httpInterceptor.put(`${this.ENDPOINTS.UPDATE}/${id}`, data);
  }

  static async deleteShipment(id) {
    return httpInterceptor.delete(`${this.ENDPOINTS.DELETE}/${id}`);
  }

  static async printReceivingLabel(data) {
    return httpInterceptor.post(this.ENDPOINTS.PRINT_RECEIVING_LABEL, data);
  }


}
